$(document).ready(function () {
    $('body').on('click', '[data-modal="h2Modal"]', function () {
        console.log('click');
        $('.overlay, #h2Modal').fadeIn('slow'); //при нажатии на кнопку появляется модальное окно
    });


    $('.h2modal_close').on('click', function () {
        $('.overlay, #h2Modal').fadeOut('slow'); //при нажатии на крестик закрываю блок
    });

});